import { AuthBrand } from '@/components/BrandMark';
import { Link } from 'react-router-dom';

export function RegisterPage() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-bg p-8">
      <div className="w-full max-w-[392px]">
        <AuthBrand title="Invitation only" subtitle="Claim System" />
        <div className="rounded-lg border border-border bg-surface p-8 shadow-sm">
          <p className="text-sm text-text-2">
            Public registration is disabled for the production pilot. Ask an administrator to create
            your account, then sign in with the credentials they send you.
          </p>
        </div>
        <p className="mt-6 text-center text-sm text-text-2">
          Already have an account?{' '}
          <Link to="/login" className="font-bold text-primary-text hover:underline">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  );
}
